

import { Globe } from 'lucide-react';
import { useI18n } from '@/i18n/context';
import { cn } from '@/lib/utils';

interface LanguageToggleProps {
  className?: string;
  variant?: 'default' | 'compact' | 'full';
}

export function LanguageToggle({ className, variant = 'default' }: LanguageToggleProps) {
  const { language, toggleLanguage, mounted } = useI18n();

  // Show placeholder during SSR to prevent hydration mismatch
  if (!mounted) {
    return (
      <button
        className={cn(
          'flex items-center gap-1 px-2 py-1 text-sm font-medium rounded-lg',
          'text-gray-600',
          className
        )}
        disabled
      >
        <Globe className="w-4 h-4" />
        <span>...</span>
      </button>
    );
  }

  if (variant === 'compact') {
    return (
      <button
        onClick={toggleLanguage}
        className={cn(
          'flex items-center gap-1 px-2 py-1 text-sm font-medium rounded-lg transition-colors',
          'text-gray-600 hover:text-gray-900 hover:bg-gray-100',
          className
        )}
        title={language === 'en' ? '切换到中文' : 'Switch to English'}
      >
        <Globe className="w-4 h-4" />
        <span>{language === 'en' ? '中文' : 'EN'}</span>
      </button>
    );
  }

  if (variant === 'full') {
    return (
      <button
        onClick={toggleLanguage}
        className={cn(
          'flex items-center gap-2 w-full px-3 py-2 text-sm font-medium rounded-lg transition-colors',
          'text-gray-600 hover:text-gray-900 hover:bg-gray-100',
          className
        )}
        title={language === 'en' ? '切换到中文' : 'Switch to English'}
      >
        <Globe className="w-4 h-4" />
        <span>{language === 'en' ? '切换到中文' : 'Switch to English'}</span>
      </button>
    );
  }

  return (
    <button
      onClick={toggleLanguage}
      className={cn(
        'flex items-center gap-2 px-3 py-2 text-sm font-medium rounded-lg transition-colors',
        'bg-gray-100 text-gray-700 hover:bg-gray-200',
        className
      )}
      title={language === 'en' ? '切换到中文' : 'Switch to English'}
    >
      <Globe className="w-4 h-4" />
      <span>{language === 'en' ? '中文' : 'English'}</span>
    </button>
  );
}
